import {Pipe, PipeTransform} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {ServiceApi} from "../../network/service/service.api";

@Pipe({
  name: 'onlinetranslate',
  standalone: false,
  pure: false
})
export class OnlineTranslate implements PipeTransform {
  constructor(private translateService: TranslateService, private serviceApi: ServiceApi) {
  }

  transform(text: string): string {
    // if (this.translateService.getDefaultLang() === this.translateService.currentLang) {
    return text;
    // } else {
    // let letter = Config.letters.find((letter) => {
    //   return text === letter.Source && letter.SourceLanguage === this.translateService.getDefaultLang() && letter.TargetLanguage === this.translateService.currentLang;
    // });
    // if (letter) {
    //   return letter.Target;
    // } else {
    //   let letter = {
    //     Source: text,
    //     Target: '',
    //     SourceLanguage: this.translateService.getDefaultLang(),
    //     TargetLanguage: this.translateService.currentLang
    //   };
    //   Config.letters.push(letter);
    //   this.serviceApi.postTranslate(this.translateService.getDefaultLang(), this.translateService.currentLang, text!).subscribe((res: ListResponse<any>) => {
    //     if (res.data && res.data.length === 1) {
    //       if (res.data[0].Target) {
    //         letter.Target = res.data[0].Target;
    //         new LetterDataSource(this.dbService).save({
    //           Source: text,
    //           Target: res.data[0].Target,
    //           SourceLanguage: this.translateService.getDefaultLang(),
    //           TargetLanguage: this.translateService.currentLang
    //         });
    //       } else {
    //       }
    //     }
    //   });
    //   return letter.Target;
    // }
    // return '';
    // }
  }
}
